document.addEventListener('DOMContentLoaded',()=>{
  const body=document.body;
  document.querySelectorAll('.loam-menu-toggle').forEach(btn=>btn.addEventListener('click',()=>{const nav=document.querySelector('.loam-mobile-nav');const open=nav?.classList.toggle('open');btn.setAttribute('aria-expanded',open?'true':'false')}));
  document.querySelectorAll('.loam-cart-toggle').forEach(btn=>btn.addEventListener('click',()=>body.classList.add('cart-open')));
  document.querySelectorAll('[data-cart-close]').forEach(btn=>btn.addEventListener('click',()=>body.classList.remove('cart-open')));

  document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
    const track=gallery.querySelector('[data-gallery-track]');
    const slides=[...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
    const current=gallery.querySelector('[data-gallery-current]');
    let active=0;
    let frame;
    const update=(index,revealThumb=false)=>{
      active=Math.max(0,Math.min(slides.length-1,index));
      if(current)current.textContent=String(active+1);
      thumbs.forEach((thumb,i)=>{
        thumb.classList.toggle('active',i===active);
        thumb.setAttribute('aria-current',i===active?'true':'false');
      });
      if(revealThumb)thumbs[active]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    };
    const go=index=>{
      if(!slides.length)return;
      const target=(index+slides.length)%slides.length;
      track.scrollTo({left:target*track.clientWidth,behavior:'smooth'});
      update(target,true);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>go(active-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>go(active+1));
    thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>go(index)));
    track?.addEventListener('scroll',()=>{
      cancelAnimationFrame(frame);
      frame=requestAnimationFrame(()=>{
        const nextIndex=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
        if(nextIndex!==active)update(nextIndex,true);
      });
    },{passive:true});
    track?.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();go(active-1)}
      if(event.key==='ArrowRight'){event.preventDefault();go(active+1)}
    });
    update(0);
  });

  document.querySelectorAll('[data-loam-ingredient-card]').forEach(card=>{
    const setFlipped=flipped=>{
      card.classList.toggle('is-flipped',flipped);
      card.setAttribute('aria-pressed',flipped?'true':'false');
      card.setAttribute('aria-label',`${flipped?'Hide':'Show'} details for ${card.querySelector('h3')?.textContent.trim()||'ingredient'}`);
      const front=card.querySelector('.loam-pdp-ingredient-front');
      const back=card.querySelector('.loam-pdp-ingredient-back');
      if(front)front.setAttribute('aria-hidden',flipped?'true':'false');
      if(back)back.setAttribute('aria-hidden',flipped?'false':'true');
    };
    card.addEventListener('click',()=>setFlipped(!card.classList.contains('is-flipped')));
    card.addEventListener('keydown',event=>{
      if(event.key==='Enter'||event.key===' '){event.preventDefault();setFlipped(!card.classList.contains('is-flipped'))}
    });
  });

  document.querySelectorAll('[data-loam-reviews]').forEach(section=>{
    const track=section.querySelector('[data-review-track]');
    const controls=section.querySelector('.loam-pdp-review-controls');
    const amount=()=>{
      const card=track?.querySelector('.loam-pdp-review-card');
      return card ? card.getBoundingClientRect().width+18 : 320;
    };
    const updateState=()=>{
      const single=(track?.querySelectorAll('.loam-pdp-review-card').length||0)<=1;
      track?.classList.toggle('is-single',single);
      if(controls)controls.hidden=single||track.scrollWidth<=track.clientWidth+2;
    };
    section.querySelector('[data-review-prev]')?.addEventListener('click',()=>track?.scrollBy({left:-amount(),behavior:'smooth'}));
    section.querySelector('[data-review-next]')?.addEventListener('click',()=>track?.scrollBy({left:amount(),behavior:'smooth'}));
    updateState();
    window.addEventListener('resize',updateState,{passive:true});
  });

  document.querySelectorAll('[data-product-section]').forEach(root=>{
    let format='pouch';
    const variantInput=root.querySelector('[data-variant-id]');
    const addPrice=root.querySelector('[data-add-price]');
    const addButton=root.querySelector('[data-add-button]');
    const buyNowButton=root.querySelector('[data-buy-now]');
    const bundles=[...root.querySelectorAll('[data-loam-bundle]')];
    const quantityInput=root.querySelector('[data-bundle-quantity]');

    const selectBundle=bundle=>{
      bundles.forEach(card=>{card.classList.toggle('selected',card===bundle);const radio=card.querySelector('input');if(radio)radio.checked=card===bundle});
      const prefix=format==='grab'?'grab':'pouch';
      const id=bundle.dataset[`${prefix}Id`];
      const price=bundle.dataset[`${prefix}Price`];
      if(id)variantInput.value=id;
      if(quantityInput)quantityInput.value=bundle.dataset.quantity||'1';
      if(price)addPrice.textContent=price;
      if(addButton)addButton.disabled=!id;
      if(buyNowButton)buyNowButton.disabled=!id;
    };

    root.querySelectorAll('[data-loam-format]').forEach(btn=>btn.addEventListener('click',()=>{
      format=btn.dataset.loamFormat;
      root.querySelectorAll('[data-loam-format]').forEach(el=>el.classList.toggle('selected',el===btn));
      bundles.forEach(bundle=>{
        const prefix=format==='grab'?'grab':'pouch';
        const price=bundle.dataset[`${prefix}Price`]||'';
        const compare=bundle.dataset[`${prefix}Compare`]||'';
        const save=bundle.dataset[`${prefix}Save`]||'';
        const each=bundle.dataset[`${prefix}Each`]||'';
        const priceNode=bundle.querySelector('[data-bundle-price]');
        const compareNode=bundle.querySelector('[data-bundle-compare]');
        const saveNode=bundle.querySelector('[data-bundle-save]');
        const eachNode=bundle.querySelector('[data-bundle-each]');
        const discountNode=bundle.querySelector('[data-bundle-discount]');
        if(priceNode)priceNode.textContent=price;
        if(compareNode){compareNode.textContent=compare;compareNode.hidden=!compare}
        if(saveNode){saveNode.textContent=save;saveNode.hidden=!save}
        if(eachNode)eachNode.textContent=each;
        if(discountNode){discountNode.textContent=bundle.dataset.discount||'';discountNode.hidden=!bundle.dataset.discount}
      });
      selectBundle(root.querySelector('[data-loam-bundle].selected')||bundles[0]);
    }));
    bundles.forEach(bundle=>bundle.addEventListener('click',()=>selectBundle(bundle)));
    if(bundles[0])selectBundle(bundles[0]);
  });

  document.querySelectorAll('[data-buy-now]').forEach(button=>button.addEventListener('click',()=>{
    const form=button.closest('form.loam-product-form');
    const variantId=form?.querySelector('[name="id"]')?.value;
    const quantity=form?.querySelector('[name="quantity"]')?.value||'1';
    if(!variantId)return;
    button.disabled=true;
    button.textContent='LOADING…';
    const root=window.Shopify?.routes?.root||'/';
    window.location.assign(`${root}cart/${encodeURIComponent(variantId)}:${encodeURIComponent(quantity)}?checkout`);
  }));

  document.querySelectorAll('form.loam-product-form').forEach(form=>form.addEventListener('submit',async event=>{
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    const original=button.innerHTML;
    button.disabled=true;
    button.textContent='ADDING…';
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(form.querySelector('[name="id"]').value),quantity:Number(form.querySelector('[name="quantity"]')?.value||1)}]})});
      if(!response.ok)throw new Error('Cart error');
      location.reload();
    }catch(error){button.textContent='PLEASE TRY AGAIN';setTimeout(()=>{button.innerHTML=original;button.disabled=false},1600)}
  }));
});
